import gql from 'graphql-tag'
import base from '@/mixins/pagination/base'
import searchUsers from '@/mixins/pagination/providers/searchUsers'

export default {
  data () {
    return {
      users: {},
      usersConcated: [],
      limit: 20,
      offset: 0,
      info: {},
    }
  },

  computed: {
    /**
     * Gives user list data
     * @returns {Array}
     */
    getData () {
      return this.usersConcated || []
    },

    /**
     * Gives user list to be displayed
     * @returns {Array}
     */
    userList () {
      return this.getData
    },

    getPaginationParams () {
      return this.info || {}
    },
  },

  mixins: [
    base,
    searchUsers,
  ],

  // Apollo...
  apollo: {
    users: {
      query: gql`query ($limit: Int, $offset: Int) {
        users (limit: $limit, offset: $offset) {
          info {
            total
          },
          set {
            id,
            name,
            email,
            mediaPlanEvents {
              info {
                total
              }
            },
            contact {
              companyName,
              contactPerson,
              phone,
              vatId
            }
          }
        }
      }`,

      variables () {
        return {
          limit: this.limit,
          offset: this.getOffset
        }
      },

      // On result, concat users, increment offset
      result (result) {
        if (result.loading) return
        let { data: { users: { set, info } } } = result

        this.$set(this, 'usersConcated', set)
        this.$set(this, 'info', info)
      },

      skip () {
        return !!this.query
      },

      fetchPolicy: 'no-cache'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/pagination/providers/userList.js